import { useTranslation } from 'react-i18next'

import {
  usePostHogFeatureFlag,
  POSTHOG_FEATURE_FLAGS
} from '@percent/admin-dashboard/common/hooks/usePostHogFeatureFlag'
import { Icon, Menu, type SectionItem } from '@percent/lemonade'
import { DonationsActionsMenuProps } from './DonationsActionsMenu.types'

export function DonationsActionsMenu({
  handleViewRaw,
  handleAddToReassignmentQueue,
  handleReassignMarkedDonation,
  handleRemoveFromReassignmentQueue,
  donation,
  isReassignDisabled,
  handleEditDonation,
  onSelectDonation,
  triggerClassName,
  isEditDonationDisabled
}: DonationsActionsMenuProps) {
  const reassignDonationFeatureFlag = usePostHogFeatureFlag(POSTHOG_FEATURE_FLAGS.AD_REASSIGN_DONATION)
  const isDonationInReassignmentQueue = donation.pendingReassignment
  const isMatchedDonation = donation.type === 'matched'

  const { t } = useTranslation()

  const handleAction = (action: () => void) => () => {
    onSelectDonation(donation)

    action()
  }

  const mainItems: SectionItem[] = [
    {
      key: 'viewRaw',
      label: t('button.viewRaw'),
      onClick: handleAction(handleViewRaw)
    },
    ...(isMatchedDonation
      ? [
          {
            key: 'editDonation',
            label: t('button.editDonation'),
            onClick: handleAction(handleEditDonation),
            shouldBeDisabled: isEditDonationDisabled
          }
        ]
      : []),
    ...(reassignDonationFeatureFlag && isDonationInReassignmentQueue
      ? [
          {
            key: 'reassignDonation',
            label: t('button.reassignMarkedDonation'),
            onClick: handleAction(handleReassignMarkedDonation),
            shouldBeDisabled: isReassignDisabled
          },
          {
            key: 'removeFromQueue',
            label: t('button.removeFromReassignmentQueue'),
            onClick: handleAction(handleRemoveFromReassignmentQueue),
            shouldBeDisabled: isReassignDisabled
          }
        ]
      : []),
    ...(reassignDonationFeatureFlag && !isDonationInReassignmentQueue
      ? [
          {
            key: 'addToQueue',
            label: t('button.addDonationToReassignmentQueue'),
            onClick: handleAction(handleAddToReassignmentQueue),
            shouldBeDisabled: isReassignDisabled
          }
        ]
      : [])
  ]

  return (
    <Menu
      sections={[{ items: mainItems }]}
      customTriggerComponent={
        <span role="button" data-testid="actions-menu" className={triggerClassName}>
          <span data-testid={`actions-menu-trigger-${donation.id}`}>
            <Icon name="menu-vertical" size="s" color="neutral400" />
          </span>
        </span>
      }
    />
  )
}
